import { z } from "zod";
import { LocaleSchema } from "./menu.js";

export const I18nOverrideSchema = z.object({
  locale: LocaleSchema,
  key: z.string().min(1).max(200),
  value: z.string().max(2000),
  updatedAt: z.string().datetime(),
});
export type I18nOverride = z.infer<typeof I18nOverrideSchema>;

export const I18nBundleSchema = z.object({
  locale: LocaleSchema,
  keys: z.record(z.string()),
  etag: z.string(),
});
export type I18nBundle = z.infer<typeof I18nBundleSchema>;
